/**
 * "Uyarı Kutusu" eklentisi.
 *
 */

const BUTTON_LABEL = 'Uyarı Kutusu';
const BUTTON_TOOLTIP = 'Uyarı kutusu ekle';

const ICON_SVG = `
<svg class="ck ck-icon ck-button__icon" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 1.5 18.5 17H1.5L10 1.5Z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
    <rect x="9.1" y="7" width="1.8" height="5" rx="0.9" fill="currentColor"/>
    <rect x="9.1" y="13.2" width="1.8" height="1.8" rx="0.9" fill="currentColor"/>
</svg>`;

function escapeHtml(text) {
    return String(text)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
}

export function buildWarningBoxHtml(text) {
    return `<div style="margin-bottom:20px;">` +
        `<div style="` +
            `background-color: rgba(31, 159, 233, 0.2);` +
            `border: 1px dashed rgb(31, 159, 233);` +
            `border-radius: 3px;` +
            `color: rgb(14, 93, 142);` +
            `padding: 15px 20px;` +
            `font-weight: 500;` +
        `">` +
            `<strong>${escapeHtml(text)}</strong>` +
        `</div>` +
    `</div>`;
}

function getSelectedText(editor) {
    let selectedText = '';

    for (const range of editor.model.document.selection.getRanges()) {
        for (const item of range.getItems()) {
            if (item.is('$text') || item.is('$textProxy')) {
                selectedText += item.data;
            }
        }
    }

    return selectedText;
}

export function insertWarningBox(editor, text) {
    const html = buildWarningBoxHtml(text);
    const viewFragment = editor.data.processor.toView(html);
    const modelFragment = editor.data.toModel(viewFragment);

    editor.model.insertContent(modelFragment);
    editor.editing.view.focus();
}

/**
 * @param {Object} editor
 * @param {Function} onRequest
 */
export default function installWarningBox(editor, onRequest) {
    const toolbarElement = editor.ui.view.toolbar && editor.ui.view.toolbar.element;

    if (!toolbarElement) {
        return;
    }

    if (toolbarElement.querySelector('.ck-warning-box-button')) {
        return;
    }

    const itemsContainer = toolbarElement.querySelector('.ck-toolbar__items') || toolbarElement;

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'ck ck-button ck-off ck-button_with-text ck-warning-box-button';
    button.setAttribute('data-cke-tooltip-text', BUTTON_TOOLTIP);
    button.innerHTML = `${ICON_SVG}<span class="ck ck-button__label">${BUTTON_LABEL}</span>`;

    button.addEventListener('mousedown', event => event.preventDefault());

    button.addEventListener('click', () => {
        const defaultText = getSelectedText(editor);

        if (typeof onRequest === 'function') {
            onRequest(defaultText);
        }
    });

    itemsContainer.appendChild(button);
}
